import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { brandManagerGuard } from './core/auth/brand-manager.guard';
import { SpikeLandingComponent } from './_spike/shell/landing/spike-landing.component';
import { CustomerDetailComponent } from './layout/customer-detail/customer-detail.component';
import { CustomerInformationComponent } from './features/customer-information/customer-information.component';
import { ContractsComponent } from './features/contracts/contracts.component';
import { SmtComponent } from './features/smt/smt.component';
import { InvoiceComponent } from './features/invoice/invoice.component';
import { TariffCheckComponent } from './features/tariff-check/tariff-check.component';
import { CallsComponent } from './features/calls/calls.component';
import { PlaceholderPageComponent } from './shared/placeholder-page/placeholder-page.component';
import { UserAccountInfoComponent } from './features/user-account-info/user-account-info.component';
import { PhoneServiceInfoComponent } from './features/phone-service-info/phone-service-info.component';
import { ReachabilitiesComponent } from './features/reachabilities/reachabilities.component';
import { ContactsListComponent } from './features/contacts/contacts-list.component';
import { CcNumbersComponent } from './features/cc-numbers/cc-numbers.component';
import { CommunicationComponent } from './features/communication/communication.component';
import { NotificationsForwardingsComponent } from './features/notifications-forwardings/notifications-forwardings.component';
import { BrandListComponent } from './features/brands/brand-list/brand-list.component';
import { BrandFormPageComponent } from './features/brands/brand-form/brand-form-page.component';
import { BrandNumberBlocksPageComponent } from './features/brands/numberblocks/brand-number-blocks-page.component';
import { AdminShellComponent } from './features/brands/admin-shell/admin-shell.component';
import { DomainListComponent } from './features/brands/domains/domain-list/domain-list.component';
import { BrandDomainsPageComponent } from './features/brands/domains/brand-domains-page.component';
import { SearchGateway } from './features/search/unified/search-gateway';
import { RealSearchGateway } from './features/search/unified/real-search-gateway';
import { LandingComponent } from './layout/landing/landing.component';

export const appRoutes: Routes = [
  // EB-3621 / EB-4074: unified-search landing with server-side customer merge.
  {
    path: '',
    component: LandingComponent,
    canActivate: [authGuard],
    providers: [{ provide: SearchGateway, useClass: RealSearchGateway }],
  },
  { path: 'calls', component: CallsComponent, canActivate: [authGuard] },
  // The preserved legacy AG-Grid search, reachable via the "Classic search" switch-back button
  // on the landing. MUST stay before the ':customerId' catch-all.
  { path: 'classic-search', component: SpikeLandingComponent, canActivate: [authGuard] },
  // Admin routes — must come BEFORE :customerId catch-all. Grouped under a
  // single `admin` parent so the guard is declared once and additional admin
  // pages can drop in as children without copy-pasting `canActivate`.
  {
    path: 'admin',
    canActivate: [authGuard, brandManagerGuard],
    children: [
      {
        path: '',
        component: AdminShellComponent,
        children: [
          { path: '', redirectTo: 'brands', pathMatch: 'full' },
          { path: 'brands', component: BrandListComponent },
          { path: 'domains', component: DomainListComponent },
        ],
      },
      { path: 'brands/new', component: BrandFormPageComponent },
      { path: 'brands/:brandId/edit', component: BrandFormPageComponent },
      { path: 'brands/:brandId/numberblocks', component: BrandNumberBlocksPageComponent },
      { path: 'brands/:brandId/domains', component: BrandDomainsPageComponent },
    ],
  },
  {
    path: ':customerId',
    component: CustomerDetailComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'information', pathMatch: 'full' },
      { path: 'information', component: CustomerInformationComponent },
      { path: 'smt', component: SmtComponent },
      { path: 'contracts', component: ContractsComponent },
      { path: 'invoice', component: InvoiceComponent },
      { path: 'tariffcheck', component: TariffCheckComponent },
      // UA routes
      { path: 'ua/:userAccountId/account-details', component: UserAccountInfoComponent },
      { path: 'ua/:userAccountId/communication', component: CommunicationComponent },
      // PS routes
      { path: 'ps/:phoneServiceId/settings', component: PhoneServiceInfoComponent },
      { path: 'ps/:phoneServiceId/reachabilities', component: ReachabilitiesComponent },
      { path: 'ps/:phoneServiceId/numbers', component: CcNumbersComponent },
      { path: 'ps/:phoneServiceId/notifications', component: NotificationsForwardingsComponent },
      { path: 'ps/:phoneServiceId/contacts', component: ContactsListComponent },
    ],
  },
  { path: '**', redirectTo: '' },
];
